import { makeAutoObservable } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

class DynamicListStore {
  defaultStateValues = {
    paginationState: {
      pageIndex: 0,
      pageSize: 10,
    },
    filters: [],
    sortingState: [],
  };

  params = JSON.stringify(this.defaultStateValues);

  constructor(rootStore, storeName) {
    this.rootStore = rootStore;
    this.storeName = storeName;
    makeAutoObservable(this);

    makePersistable(this, {
      name: storeName,
      properties: ['params'],
    });
  }

  getListValue(storeName, value) {
    return {
      paginationState: {
        ...this.defaultStateValues.paginationState,
        ...value?.paginationState,
      },
      sortingState: [
        ...this.defaultStateValues.sortingState,
        ...(value?.sortingState || []),
      ],
      filters: [...(value?.filters || [])],
    };
  }

  reset(storeName) {
    const current = JSON.parse(this.rootStore.uiState[storeName].params);
    const newData = {
      ...current,
      ...{
        paginationState: this.defaultStateValues.paginationState,
        sortingState: this.defaultStateValues.sortingState,
        filters: [],
      },
    };
    const stringifiedData = JSON.stringify(newData);
    this.rootStore.uiState[storeName].params = stringifiedData;
  }

  set(storeName, value) {
    if (value) {
      const current = JSON.parse(this.rootStore.uiState[storeName].params);
      const newValue = this.getListValue(storeName, value);
      const newData = {
        ...current,
        ...newValue,
      };
      const stringifiedData = JSON.stringify(newData);
      this.rootStore.uiState[storeName].params = stringifiedData;
    }
  }

  get(storeName, defaultStateValues = null) {
    const data = JSON.parse(this.rootStore.uiState[storeName].params);
    if (!data) {
      this.set(storeName, defaultStateValues || {});
    }
    return data || this.defaultStateValues;
  }

  async clearStore() {
    await clearPersistedStore(this);
  }
}

export default DynamicListStore;
